/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.loomi = (function() {

    /**
     * Namespace loomi.
     * @exports loomi
     * @namespace
     */
    var loomi = {};

    loomi.binary = (function() {

        /**
         * Namespace binary.
         * @memberof loomi
         * @namespace
         */
        var binary = {};

        binary.Catalog = (function() {

            /**
             * Properties of a Catalog.
             * @memberof loomi.binary
             * @interface ICatalog
             * @property {Array.<loomi.binary.ICollection>|null} [collections] Catalog collections
             * @property {Array.<loomi.binary.ICatalogProduct>|null} [products] Catalog products
             * @property {Array.<string>|null} [productTags] Catalog productTags
             * @property {boolean|null} [reviewsEnabled] Catalog reviewsEnabled
             * @property {Array.<string>|null} [currencies] Catalog currencies
             * @property {number|null} [productCount] Catalog productCount
             * @property {Array.<string>|null} [customerTags] Catalog customerTags
             * @property {string|null} [mainAttribute] Catalog mainAttribute
             * @property {Array.<string>|null} [mainAttributeOptions] Catalog mainAttributeOptions
             * @property {Array.<string>|null} [productTagDictionary] Catalog productTagDictionary
             * @property {Uint8Array|null} [productTagRelationData] Catalog productTagRelationData
             * @property {Uint8Array|null} [productTagRelationOffsets] Catalog productTagRelationOffsets
             * @property {Uint8Array|null} [productTagRelationFormats] Catalog productTagRelationFormats
             * @property {Array.<string>|null} [productCollectionDictionary] Catalog productCollectionDictionary
             * @property {Uint8Array|null} [productCollectionRelationData] Catalog productCollectionRelationData
             * @property {Uint8Array|null} [productCollectionRelationOffsets] Catalog productCollectionRelationOffsets
             * @property {Uint8Array|null} [productCollectionRelationFormats] Catalog productCollectionRelationFormats
             */

            /**
             * Constructs a new Catalog.
             * @memberof loomi.binary
             * @classdesc Represents a Catalog.
             * @implements ICatalog
             * @constructor
             * @param {loomi.binary.ICatalog=} [properties] Properties to set
             */
            function Catalog(properties) {
                this.collections = [];
                this.products = [];
                this.productTags = [];
                this.currencies = [];
                this.customerTags = [];
                this.mainAttributeOptions = [];
                this.productTagDictionary = [];
                this.productCollectionDictionary = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Catalog collections.
             * @member {Array.<loomi.binary.ICollection>} collections
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.collections = $util.emptyArray;

            /**
             * Catalog products.
             * @member {Array.<loomi.binary.ICatalogProduct>} products
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.products = $util.emptyArray;

            /**
             * Catalog productTags.
             * @member {Array.<string>} productTags
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productTags = $util.emptyArray;

            /**
             * Catalog reviewsEnabled.
             * @member {boolean} reviewsEnabled
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.reviewsEnabled = false;

            /**
             * Catalog currencies.
             * @member {Array.<string>} currencies
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.currencies = $util.emptyArray;

            /**
             * Catalog productCount.
             * @member {number} productCount
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productCount = 0;

            /**
             * Catalog customerTags.
             * @member {Array.<string>} customerTags
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.customerTags = $util.emptyArray;

            /**
             * Catalog mainAttribute.
             * @member {string} mainAttribute
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.mainAttribute = "";

            /**
             * Catalog mainAttributeOptions.
             * @member {Array.<string>} mainAttributeOptions
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.mainAttributeOptions = $util.emptyArray;

            /**
             * Catalog productTagDictionary.
             * @member {Array.<string>} productTagDictionary
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productTagDictionary = $util.emptyArray;

            /**
             * Catalog productTagRelationData.
             * @member {Uint8Array} productTagRelationData
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productTagRelationData = $util.newBuffer([]);

            /**
             * Catalog productTagRelationOffsets.
             * @member {Uint8Array} productTagRelationOffsets
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productTagRelationOffsets = $util.newBuffer([]);

            /**
             * Catalog productTagRelationFormats.
             * @member {Uint8Array} productTagRelationFormats
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productTagRelationFormats = $util.newBuffer([]);

            /**
             * Catalog productCollectionDictionary.
             * @member {Array.<string>} productCollectionDictionary
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productCollectionDictionary = $util.emptyArray;

            /**
             * Catalog productCollectionRelationData.
             * @member {Uint8Array} productCollectionRelationData
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productCollectionRelationData = $util.newBuffer([]);

            /**
             * Catalog productCollectionRelationOffsets.
             * @member {Uint8Array} productCollectionRelationOffsets
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productCollectionRelationOffsets = $util.newBuffer([]);

            /**
             * Catalog productCollectionRelationFormats.
             * @member {Uint8Array} productCollectionRelationFormats
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productCollectionRelationFormats = $util.newBuffer([]);

            /**
             * Encodes the specified Catalog message. Does not implicitly {@link loomi.binary.Catalog.verify|verify} messages.
             * @function encode
             * @memberof loomi.binary.Catalog
             * @static
             * @param {loomi.binary.ICatalog} message Catalog message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Catalog.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.collections != null && message.collections.length)
                    for (var i = 0; i < message.collections.length; ++i)
                        $root.loomi.binary.Collection.encode(message.collections[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.products != null && message.products.length)
                    for (var i = 0; i < message.products.length; ++i)
                        $root.loomi.binary.CatalogProduct.encode(message.products[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.productTags != null && message.productTags.length)
                    for (var i = 0; i < message.productTags.length; ++i)
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.productTags[i]);
                if (message.reviewsEnabled != null && Object.hasOwnProperty.call(message, "reviewsEnabled"))
                    writer.uint32(/* id 4, wireType 0 =*/32).bool(message.reviewsEnabled);
                if (message.currencies != null && message.currencies.length)
                    for (var i = 0; i < message.currencies.length; ++i)
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.currencies[i]);
                if (message.productCount != null && Object.hasOwnProperty.call(message, "productCount"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.productCount);
                if (message.customerTags != null && message.customerTags.length)
                    for (var i = 0; i < message.customerTags.length; ++i)
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.customerTags[i]);
                if (message.mainAttribute != null && Object.hasOwnProperty.call(message, "mainAttribute"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.mainAttribute);
                if (message.mainAttributeOptions != null && message.mainAttributeOptions.length)
                    for (var i = 0; i < message.mainAttributeOptions.length; ++i)
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.mainAttributeOptions[i]);
                if (message.productTagDictionary != null && message.productTagDictionary.length)
                    for (var i = 0; i < message.productTagDictionary.length; ++i)
                        writer.uint32(/* id 11, wireType 2 =*/90).string(message.productTagDictionary[i]);
                if (message.productTagRelationData != null && Object.hasOwnProperty.call(message, "productTagRelationData"))
                    writer.uint32(/* id 12, wireType 2 =*/98).bytes(message.productTagRelationData);
                if (message.productTagRelationOffsets != null && Object.hasOwnProperty.call(message, "productTagRelationOffsets"))
                    writer.uint32(/* id 13, wireType 2 =*/106).bytes(message.productTagRelationOffsets);
                if (message.productTagRelationFormats != null && Object.hasOwnProperty.call(message, "productTagRelationFormats"))
                    writer.uint32(/* id 14, wireType 2 =*/114).bytes(message.productTagRelationFormats);
                if (message.productCollectionDictionary != null && message.productCollectionDictionary.length)
                    for (var i = 0; i < message.productCollectionDictionary.length; ++i)
                        writer.uint32(/* id 15, wireType 2 =*/122).string(message.productCollectionDictionary[i]);
                if (message.productCollectionRelationData != null && Object.hasOwnProperty.call(message, "productCollectionRelationData"))
                    writer.uint32(/* id 16, wireType 2 =*/130).bytes(message.productCollectionRelationData);
                if (message.productCollectionRelationOffsets != null && Object.hasOwnProperty.call(message, "productCollectionRelationOffsets"))
                    writer.uint32(/* id 17, wireType 2 =*/138).bytes(message.productCollectionRelationOffsets);
                if (message.productCollectionRelationFormats != null && Object.hasOwnProperty.call(message, "productCollectionRelationFormats"))
                    writer.uint32(/* id 18, wireType 2 =*/146).bytes(message.productCollectionRelationFormats);
                return writer;
            };

            /**
             * Decodes a Catalog message from the specified reader or buffer.
             * @function decode
             * @memberof loomi.binary.Catalog
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {loomi.binary.Catalog} Catalog
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Catalog.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.loomi.binary.Catalog();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.collections && message.collections.length))
                                message.collections = [];
                            message.collections.push($root.loomi.binary.Collection.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            if (!(message.products && message.products.length))
                                message.products = [];
                            message.products.push($root.loomi.binary.CatalogProduct.decode(reader, reader.uint32()));
                            break;
                        }
                    case 3: {
                            if (!(message.productTags && message.productTags.length))
                                message.productTags = [];
                            message.productTags.push(reader.string());
                            break;
                        }
                    case 4: {
                            message.reviewsEnabled = reader.bool();
                            break;
                        }
                    case 5: {
                            if (!(message.currencies && message.currencies.length))
                                message.currencies = [];
                            message.currencies.push(reader.string());
                            break;
                        }
                    case 6: {
                            message.productCount = reader.int32();
                            break;
                        }
                    case 7: {
                            if (!(message.customerTags && message.customerTags.length))
                                message.customerTags = [];
                            message.customerTags.push(reader.string());
                            break;
                        }
                    case 8: {
                            message.mainAttribute = reader.string();
                            break;
                        }
                    case 9: {
                            if (!(message.mainAttributeOptions && message.mainAttributeOptions.length))
                                message.mainAttributeOptions = [];
                            message.mainAttributeOptions.push(reader.string());
                            break;
                        }
                    case 11: {
                            if (!(message.productTagDictionary && message.productTagDictionary.length))
                                message.productTagDictionary = [];
                            message.productTagDictionary.push(reader.string());
                            break;
                        }
                    case 12: {
                            message.productTagRelationData = reader.bytes();
                            break;
                        }
                    case 13: {
                            message.productTagRelationOffsets = reader.bytes();
                            break;
                        }
                    case 14: {
                            message.productTagRelationFormats = reader.bytes();
                            break;
                        }
                    case 15: {
                            if (!(message.productCollectionDictionary && message.productCollectionDictionary.length))
                                message.productCollectionDictionary = [];
                            message.productCollectionDictionary.push(reader.string());
                            break;
                        }
                    case 16: {
                            message.productCollectionRelationData = reader.bytes();
                            break;
                        }
                    case 17: {
                            message.productCollectionRelationOffsets = reader.bytes();
                            break;
                        }
                    case 18: {
                            message.productCollectionRelationFormats = reader.bytes();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Gets the default type url for Catalog
             * @function getTypeUrl
             * @memberof loomi.binary.Catalog
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Catalog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/loomi.binary.Catalog";
            };

            return Catalog;
        })();

        binary.CatalogProduct = (function() {

            /**
             * Properties of a CatalogProduct.
             * @memberof loomi.binary
             * @interface ICatalogProduct
             * @property {number|Long|null} [id] CatalogProduct id
             * @property {Array.<string>|null} [collections] CatalogProduct collections
             * @property {string|null} [handle] CatalogProduct handle
             * @property {loomi.binary.IImage|null} [image] CatalogProduct image
             * @property {number|null} [price] CatalogProduct price
             * @property {string|null} [productType] CatalogProduct productType
             * @property {number|null} [rank] CatalogProduct rank
             * @property {Array.<string>|null} [tags] CatalogProduct tags
             * @property {string|null} [title] CatalogProduct title
             * @property {Array.<loomi.binary.IProductOption>|null} [options] CatalogProduct options
             * @property {Array.<number|Long>|null} [variantIds] CatalogProduct variantIds
             */

            /**
             * Constructs a new CatalogProduct.
             * @memberof loomi.binary
             * @classdesc Represents a CatalogProduct.
             * @implements ICatalogProduct
             * @constructor
             * @param {loomi.binary.ICatalogProduct=} [properties] Properties to set
             */
            function CatalogProduct(properties) {
                this.collections = [];
                this.tags = [];
                this.options = [];
                this.variantIds = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CatalogProduct id.
             * @member {number|Long} id
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * CatalogProduct collections.
             * @member {Array.<string>} collections
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.collections = $util.emptyArray;

            /**
             * CatalogProduct handle.
             * @member {string} handle
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.handle = "";

            /**
             * CatalogProduct image.
             * @member {loomi.binary.IImage|null|undefined} image
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.image = null;

            /**
             * CatalogProduct price.
             * @member {number} price
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.price = 0;

            /**
             * CatalogProduct productType.
             * @member {string} productType
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.productType = "";

            /**
             * CatalogProduct rank.
             * @member {number} rank
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.rank = 0;

            /**
             * CatalogProduct tags.
             * @member {Array.<string>} tags
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.tags = $util.emptyArray;

            /**
             * CatalogProduct title.
             * @member {string} title
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.title = "";

            /**
             * CatalogProduct options.
             * @member {Array.<loomi.binary.IProductOption>} options
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.options = $util.emptyArray;

            /**
             * CatalogProduct variantIds.
             * @member {Array.<number|Long>} variantIds
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.variantIds = $util.emptyArray;

            /**
             * Encodes the specified CatalogProduct message. Does not implicitly {@link loomi.binary.CatalogProduct.verify|verify} messages.
             * @function encode
             * @memberof loomi.binary.CatalogProduct
             * @static
             * @param {loomi.binary.ICatalogProduct} message CatalogProduct message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CatalogProduct.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                if (message.collections != null && message.collections.length)
                    for (var i = 0; i < message.collections.length; ++i)
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.collections[i]);
                if (message.handle != null && Object.hasOwnProperty.call(message, "handle"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.handle);
                if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                    $root.loomi.binary.Image.encode(message.image, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                    writer.uint32(/* id 5, wireType 5 =*/45).float(message.price);
                if (message.productType != null && Object.hasOwnProperty.call(message, "productType"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.productType);
                if (message.rank != null && Object.hasOwnProperty.call(message, "rank"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.rank);
                if (message.tags != null && message.tags.length)
                    for (var i = 0; i < message.tags.length; ++i)
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.tags[i]);
                if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.title);
                if (message.options != null && message.options.length)
                    for (var i = 0; i < message.options.length; ++i)
                        $root.loomi.binary.ProductOption.encode(message.options[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                if (message.variantIds != null && message.variantIds.length) {
                    writer.uint32(/* id 11, wireType 2 =*/90).fork();
                    for (var i = 0; i < message.variantIds.length; ++i)
                        writer.int64(message.variantIds[i]);
                    writer.ldelim();
                }
                return writer;
            };

            /**
             * Decodes a CatalogProduct message from the specified reader or buffer.
             * @function decode
             * @memberof loomi.binary.CatalogProduct
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {loomi.binary.CatalogProduct} CatalogProduct
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CatalogProduct.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.loomi.binary.CatalogProduct();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.int64();
                            break;
                        }
                    case 2: {
                            if (!(message.collections && message.collections.length))
                                message.collections = [];
                            message.collections.push(reader.string());
                            break;
                        }
                    case 3: {
                            message.handle = reader.string();
                            break;
                        }
                    case 4: {
                            message.image = $root.loomi.binary.Image.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.price = reader.float();
                            break;
                        }
                    case 6: {
                            message.productType = reader.string();
                            break;
                        }
                    case 7: {
                            message.rank = reader.int32();
                            break;
                        }
                    case 8: {
                            if (!(message.tags && message.tags.length))
                                message.tags = [];
                            message.tags.push(reader.string());
                            break;
                        }
                    case 9: {
                            message.title = reader.string();
                            break;
                        }
                    case 10: {
                            if (!(message.options && message.options.length))
                                message.options = [];
                            message.options.push($root.loomi.binary.ProductOption.decode(reader, reader.uint32()));
                            break;
                        }
                    case 11: {
                            if (!(message.variantIds && message.variantIds.length))
                                message.variantIds = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.variantIds.push(reader.int64());
                            } else
                                message.variantIds.push(reader.int64());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Gets the default type url for CatalogProduct
             * @function getTypeUrl
             * @memberof loomi.binary.CatalogProduct
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CatalogProduct.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/loomi.binary.CatalogProduct";
            };

            return CatalogProduct;
        })();

        binary.ProductOption = (function() {

            /**
             * Properties of a ProductOption.
             * @memberof loomi.binary
             * @interface IProductOption
             * @property {string|null} [name] ProductOption name
             * @property {Array.<string>|null} [values] ProductOption values
             */

            /**
             * Constructs a new ProductOption.
             * @memberof loomi.binary
             * @classdesc Represents a ProductOption.
             * @implements IProductOption
             * @constructor
             * @param {loomi.binary.IProductOption=} [properties] Properties to set
             */
            function ProductOption(properties) {
                this.values = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ProductOption name.
             * @member {string} name
             * @memberof loomi.binary.ProductOption
             * @instance
             */
            ProductOption.prototype.name = "";

            /**
             * ProductOption values.
             * @member {Array.<string>} values
             * @memberof loomi.binary.ProductOption
             * @instance
             */
            ProductOption.prototype.values = $util.emptyArray;

            /**
             * Encodes the specified ProductOption message. Does not implicitly {@link loomi.binary.ProductOption.verify|verify} messages.
             * @function encode
             * @memberof loomi.binary.ProductOption
             * @static
             * @param {loomi.binary.IProductOption} message ProductOption message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ProductOption.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.values != null && message.values.length)
                    for (var i = 0; i < message.values.length; ++i)
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.values[i]);
                return writer;
            };

            /**
             * Decodes a ProductOption message from the specified reader or buffer.
             * @function decode
             * @memberof loomi.binary.ProductOption
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {loomi.binary.ProductOption} ProductOption
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ProductOption.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.loomi.binary.ProductOption();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.name = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.values && message.values.length))
                                message.values = [];
                            message.values.push(reader.string());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Gets the default type url for ProductOption
             * @function getTypeUrl
             * @memberof loomi.binary.ProductOption
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ProductOption.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/loomi.binary.ProductOption";
            };

            return ProductOption;
        })();

        binary.Image = (function() {

            /**
             * Properties of an Image.
             * @memberof loomi.binary
             * @interface IImage
             * @property {string|null} [src] Image src
             * @property {number|null} [height] Image height
             * @property {number|null} [width] Image width
             */

            /**
             * Constructs a new Image.
             * @memberof loomi.binary
             * @classdesc Represents an Image.
             * @implements IImage
             * @constructor
             * @param {loomi.binary.IImage=} [properties] Properties to set
             */
            function Image(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Image src.
             * @member {string} src
             * @memberof loomi.binary.Image
             * @instance
             */
            Image.prototype.src = "";

            /**
             * Image height.
             * @member {number} height
             * @memberof loomi.binary.Image
             * @instance
             */
            Image.prototype.height = 0;

            /**
             * Image width.
             * @member {number} width
             * @memberof loomi.binary.Image
             * @instance
             */
            Image.prototype.width = 0;

            /**
             * Encodes the specified Image message. Does not implicitly {@link loomi.binary.Image.verify|verify} messages.
             * @function encode
             * @memberof loomi.binary.Image
             * @static
             * @param {loomi.binary.IImage} message Image message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Image.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.src != null && Object.hasOwnProperty.call(message, "src"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.src);
                if (message.height != null && Object.hasOwnProperty.call(message, "height"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.height);
                if (message.width != null && Object.hasOwnProperty.call(message, "width"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.width);
                return writer;
            };

            /**
             * Decodes an Image message from the specified reader or buffer.
             * @function decode
             * @memberof loomi.binary.Image
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {loomi.binary.Image} Image
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Image.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.loomi.binary.Image();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.src = reader.string();
                            break;
                        }
                    case 2: {
                            message.height = reader.int32();
                            break;
                        }
                    case 3: {
                            message.width = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Gets the default type url for Image
             * @function getTypeUrl
             * @memberof loomi.binary.Image
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Image.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/loomi.binary.Image";
            };

            return Image;
        })();

        binary.Collection = (function() {

            /**
             * Properties of a Collection.
             * @memberof loomi.binary
             * @interface ICollection
             * @property {number|Long|null} [id] Collection id
             * @property {string|null} [handle] Collection handle
             * @property {string|null} [title] Collection title
             */

            /**
             * Constructs a new Collection.
             * @memberof loomi.binary
             * @classdesc Represents a Collection.
             * @implements ICollection
             * @constructor
             * @param {loomi.binary.ICollection=} [properties] Properties to set
             */
            function Collection(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Collection id.
             * @member {number|Long} id
             * @memberof loomi.binary.Collection
             * @instance
             */
            Collection.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Collection handle.
             * @member {string} handle
             * @memberof loomi.binary.Collection
             * @instance
             */
            Collection.prototype.handle = "";

            /**
             * Collection title.
             * @member {string} title
             * @memberof loomi.binary.Collection
             * @instance
             */
            Collection.prototype.title = "";

            /**
             * Encodes the specified Collection message. Does not implicitly {@link loomi.binary.Collection.verify|verify} messages.
             * @function encode
             * @memberof loomi.binary.Collection
             * @static
             * @param {loomi.binary.ICollection} message Collection message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Collection.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                if (message.handle != null && Object.hasOwnProperty.call(message, "handle"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.handle);
                if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.title);
                return writer;
            };

            /**
             * Decodes a Collection message from the specified reader or buffer.
             * @function decode
             * @memberof loomi.binary.Collection
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {loomi.binary.Collection} Collection
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Collection.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.loomi.binary.Collection();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.int64();
                            break;
                        }
                    case 2: {
                            message.handle = reader.string();
                            break;
                        }
                    case 6: {
                            message.title = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Gets the default type url for Collection
             * @function getTypeUrl
             * @memberof loomi.binary.Collection
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Collection.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/loomi.binary.Collection";
            };

            return Collection;
        })();

        return binary;
    })();

    return loomi;
})();

module.exports = $root;
